enum SecurityRole {
    PRODUCTOWNER = 0,
    SPONSOR = 1,
    READONLYADMIN = 2,
    PARTICIPANT = 3,
    DFWTRAUMASUBMITTER = 4,
}
export default SecurityRole;
